"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BREADCRUMBS_MOBILE = exports.BREADCRUMBS_DESKTOP = void 0;
const BREADCRUMBS_MOBILE = exports.BREADCRUMBS_MOBILE = 'breadcrumbs-mobile';
const BREADCRUMBS_DESKTOP = exports.BREADCRUMBS_DESKTOP = 'breadcrumbs-desktop';
